export enum RequisitesStatusDetails {
  BlockConsecutiveCancellations = 'block_consecutive_cancellations',
  BlockConsecutiveDisputes = 'block_consecutive_disputes',
  BlockConsecutiveRejects = 'block_consecutive_rejects',
  BlockConsecutiveManualComplete = 'block_consecutive_manual_complete',
  BlockByManager = 'block_by_manager',
}
